import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Ariel Rotem | Senior Software Engineer & AI Researcher</title>
        <meta name="description" content="Ariel Rotem is a Senior Software Engineer specializing in Google Cloud infrastructure, cybersecurity, medical data intelligence, and AI research." />
      </Helmet>
      <div className="text-center mb-4 pt-4">
        <img 
          src="/PhotosForWebsite/portrait_129961705_10217542494531359_2427868206987008261_n.jpg"
          alt="Ariel Rotem - Senior Software Engineer and AI Researcher"
          style={{ width: '180px', height: '180px', borderRadius: '50%', border: '2px solid var(--accent-primary)', boxShadow: 'var(--glow-shadow)' }}
        />
        <h1 className="mt-4 glitch" style={{ fontSize: '3rem', marginBottom: '8px' }}>Ariel Rotem</h1>
        <h2 className="mono" style={{ color: 'var(--text-secondary)', fontSize: '1.2rem', fontWeight: '400' }}>
          &gt; Senior Software Engineer | Innovator | AI Researcher
        </h2>
      </div>

      <div className="terminal-card mt-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h3 className="mb-2" style={{ color: 'var(--accent-secondary)' }}>$ cat about_me.txt</h3>
        <p>
          I am a Senior Software Engineer with over a decade of experience specializing in high-impact domains: Google Cloud infrastructure, cybersecurity, medical data intelligence, and heavily increasingly, AI research. My core drive is solving complex problems that deliver systemic value.
        </p>
        <p>
          I focus heavily on AI, scaling long-running agentic workflows, and leveraging machine learning to empower scientific and medical research communities. 
        </p>
        <p className="mt-2" style={{ fontStyle: 'italic', color: 'var(--text-secondary)' }}>
          // Note: This website also serves to show my mom's friends what I actually do.
        </p>
      </div>

      <div className="mt-4">
        <h3 className="text-center mb-4">root@sys:~# ls -l ./roles</h3>
        <div className="grid grid-cols-2">
          
          <Link to="/software-engineer" className="terminal-card" style={{ display: 'block' }}>
            <h4 style={{ color: 'var(--accent-primary)' }}>software_engineer.exe</h4>
            <p className="mt-1" style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
              Building robust infrastructure, massive medical data intelligence pipelines, and solving complex challenges at scale.
            </p>
            <div className="mt-2 text-right">
              <span className="mono" style={{ fontSize: '0.8rem', color: 'var(--accent-primary)' }}>[ Execute ]</span>
            </div>
          </Link>

          <Link to="/innovation" className="terminal-card" style={{ display: 'block' }}>
            <h4 style={{ color: 'var(--accent-primary)' }}>ai_research_innovator.sh</h4>
            <p className="mt-1" style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
              Pro bono initiatives, AI citation discovery tools (MedCiter), custom research datasets, and patented hardware/software designs.
            </p>
            <div className="mt-2 text-right">
              <span className="mono" style={{ fontSize: '0.8rem', color: 'var(--accent-primary)' }}>[ Execute ]</span>
            </div>
          </Link>

        </div>
      </div>

      <div className="mt-4 pt-4">
        <h3 className="text-center mb-4">root@sys:~# ls -l ./protocols/human</h3>
        <div className="grid grid-cols-2">

          <Link to="/journalism" className="terminal-card" style={{ display: 'block' }}>
            <h4 style={{ color: 'var(--accent-secondary)' }}>aviation_journalist.log</h4>
            <p className="mt-1" style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
              Accredited journalist (IAPP). Capturing the world through a different lens—focusing on motorsports, aviation, and engineering marvels.
            </p>
            <div className="mt-2 text-right">
              <span className="mono" style={{ fontSize: '0.8rem', color: 'var(--accent-secondary)' }}>[ Read Log ]</span>
            </div>
          </Link>

          <Link to="/private-pilot" className="terminal-card" style={{ display: 'block' }}>
            <h4 style={{ color: 'var(--accent-secondary)' }}>private_pilot.flight</h4>
            <p className="mt-1" style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
              Exploring the world from above, embracing the strict discipline and absolute freedom of aviation.
            </p>
            <div className="mt-2 text-right">
              <span className="mono" style={{ fontSize: '0.8rem', color: 'var(--accent-secondary)' }}>[ Read Log ]</span>
            </div>
          </Link>

        </div>
      </div>

    </div>
  );
};

export default Home;
